export default {
  meta: {
    title: $localize`:@@meta.jackpot.home.title:CS2 Jackpot CSFAIL - Джекпот CSGO`,
    description: $localize`:@@meta.jackpot.home.desc:Попробуйте свой шанс в джекпоте CS2 на CSFAIL. Выигрывайте крупные призы, играя в захватывающую рулетку и наслаждаясь азартом.`
  }
};